import $ from "jquery"

$(() => {
  var hash = document.location.hash

  if (hash) {
    $(`.nav a[href="${hash}"]`).tab("show")
  }
})
